module.exports = __webpack_public_path__ + "static/img/324.4c60c17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/210427/324.jpg
// module id = WOLJ
// module chunks = 0